<div class="modal-overlay">
  <div class="modal-box">
    <button class="close-btn" (click)="onClose()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>

    <h2 class="progress-title">Ingesting your batch</h2>
    <p class="progress-subtitle">This may take a while.</p>

    <div class="progress-track">
      <div class="progress-fill" [style.width.%]="percent()"></div>
    </div>
    <p class="progress-percent">{{ percent() }}% completed</p>
  </div>
</div>
